import NotificacionAdapter from '../adapters/Notificacion.adapter'

export default class GetAllNotificacionesUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute() {
    try {
      const { data } = await this.#repository.getAll()
      const notificaciones = data
        .sort((a, b) => new Date(b.fechaCreacion) - new Date(a.fechaCreacion))
        .map((notificacionDto) => NotificacionAdapter.toDomain(notificacionDto))

      return notificaciones
    } catch {
      throw new Error(`Failed to execute GetAllNotificationesUseCase`)
    }
  }
}
